<template>
<pre v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            return hljs.highlight(`
// config/session.php
[
  'secure' => ${this.attribute.value}
],
`, {language: 'php'}).value
        }
    }

}
</script>